import { IconInfoCircleOutline } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { FormattedDate, FormattedMessage } from 'react-intl';

export const OfferTimeoutAlertBox = ({
    timeoutDate
}: {
    timeoutDate: string;
}) => {
    return (
        <AlertBox variant="connect" className="flex w-full items-center gap-s">
            <IconInfoCircleOutline className="size-[20px] shrink-0" />
            <Text className="font-med">
                <FormattedMessage
                    id="_.topup_choice.offer_timeout_alertbox"
                    defaultMessage="You can configure new terms until {timeoutDate}"
                    values={{
                        timeoutDate: (
                            <FormattedDate
                                value={timeoutDate}
                                day="numeric"
                                month="short"
                                year="numeric"
                            />
                        )
                    }}
                />
            </Text>
        </AlertBox>
    );
};
